// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  background: var(--color-primary);
  padding-top: 8rem;
  box-shadow: 0 -1rem 1.5rem hsla(var(--primary-hue), 68%, 42%, 20%);
  transition: var(--transition);
}

.nav__menu {
  justify-content: center;
  align-items: center;
}

.footer__socials {
  display: flex;
  gap: 1.5rem;
  width: -moz-fit-content;
  width: fit-content;
  margin: 3rem auto 4rem;
}

.footer__socials a {
  font-size: 1.5rem;
  color: var(--color-white);
  padding: 0.6rem;
  border-radius: var(--border-radius-3);
}

.footer__socials a:hover {
  opacity: 0.7;
  transform: translateY(-0.5rem);
}

.footer__copyright {
  color: white;
  text-align: center;
  border-top: 2px solid rgba(255, 255, 255, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/pages/footer/footer.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kEAAkE;EAClE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAkB;EAAlB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;AAChD","sourcesContent":["footer {\n  background: var(--color-primary);\n  padding-top: 8rem;\n  box-shadow: 0 -1rem 1.5rem hsla(var(--primary-hue), 68%, 42%, 20%);\n  transition: var(--transition);\n}\n\n.nav__menu {\n  justify-content: center;\n  align-items: center;\n}\n\n.footer__socials {\n  display: flex;\n  gap: 1.5rem;\n  width: fit-content;\n  margin: 3rem auto 4rem;\n}\n\n.footer__socials a {\n  font-size: 1.5rem;\n  color: var(--color-white);\n  padding: 0.6rem;\n  border-radius: var(--border-radius-3);\n}\n\n.footer__socials a:hover {\n  opacity: 0.7;\n  transform: translateY(-0.5rem);\n}\n\n.footer__copyright {\n  color: white;\n  text-align: center;\n  border-top: 2px solid rgba(255, 255, 255, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
